module.exports = __webpack_public_path__ + "static/img/zdf.b7629b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/zdf.png
// module id = NkDG
// module chunks = 1